// src/environments/environment.uat.ts
export const environment = {
    production: false,
    apiUrl: 'https://fdqs23wet4.execute-api.us-east-1.amazonaws.com/Prod', // UAT API Gateway endpoint
};
